import type { Dispatch, SetStateAction } from 'react'

import type { SharedFollowingFanProjection } from '@api'
import type { PaginationState } from '@tanstack/react-table'

import { DataTable } from '@/components/ui/table/controlled-pagination/DataTable.tsx'

import { SHARED_FOLLOWERS_COLUMNS } from './constants'

interface SharedFollowersListTableProps {
  paginationState: PaginationState
  onPaginationChange: Dispatch<SetStateAction<PaginationState>>
  list: SharedFollowingFanProjection[]
  isFetching: boolean
  pageCount: number
}

export const SharedFollowersListTable = ({
  paginationState,
  onPaginationChange,
  list,
  isFetching,
  pageCount,
}: SharedFollowersListTableProps) => {
  return (
    <DataTable
      enablePagination
      columns={SHARED_FOLLOWERS_COLUMNS}
      paginationState={paginationState}
      pageCount={pageCount}
      data={list}
      onPaginationChange={onPaginationChange}
      enableSorting
      isLoading={isFetching}
      tbodyMinHeight={false}
    />
  )
}
